

/*
 * Add classes in response to scrolling
 */
document.addEventListener('scroll', function(event){

	if(window.scrollY > 0){
		document.body.classList.add('scrolled');
    } else {
		document.body.classList.remove('scrolled');
  }

});

